// extracted by mini-css-extract-plugin
export default {"section":"image-with-text-stacked_section__It7aa","htmlContent":"image-with-text-stacked_htmlContent__YiOAl"};